import Domicile from './Domicile';
import Coupon from './Coupon';
import Invoice from './Invoice';
import Locale from './Locale';
import t from 'tcomb';


const Order = t.struct({
  locale: Locale,
  domicile: t.maybe(Domicile),
  coupon: t.maybe(Coupon),
  invoice: t.maybe(Invoice)
}, 'Order');


module.exports = Order;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Order.js
 **/